import React from "react";

import SPUtilities from "../util/SPUtilities";
import Utilities from "../util/Utilities";
import RespUtils from "../util/RespUtils";
import AddressUtils from "../util/AddressUtils";
import LogoUtils from "../util/LogoUtils";
import UIUtils from "../util/UIUtils";

class OasisUtils extends React.Component {
  static poolNameFormatter(cell, row) {
    return OasisUtils.websiteLink(cell, row.website);
  }

  static websiteLink(label, link) {
    if (!label) {
      return label;
    }

    if (!link) {
      return label;
    }

    return (<a className="black-a" target="_blank"
      href={SPUtilities.getUrl(link)}>{label}</a>);
  }

  static entityFormatter(cell, row) {
    // console.log(cell);
    if (!cell) {
      return (<span><a className="black-a" href={"/pool/" + row.poolId}
        >{SPUtilities.addressLabelShortFormatter(row.idAddress, row, true)}</a>{UIUtils.getRiskyInd(row.risky)}</span>);
    }

    return (<span><a className="black-a" href={"/pool/" + row.poolId}
      >{cell}</a>{UIUtils.getRiskyInd(row.risky)}</span>);
  }

  static entityNameFormatter(pool) {
    // console.log(cell);
    if (!pool.entityName) {
      return <span>{LogoUtils.logoFormatter(pool.idAddress, pool.website, true, pool.hasLogo, pool.keybaseLogo)} {
        AddressUtils.addressFormatterSimpleNoCopy(pool.idAddress)}</span>;
    }

    return <span>{LogoUtils.logoFormatter(pool.idAddress, pool.website, true, pool.hasLogo, pool.keybaseLogo)} {pool.entityName}</span>;;
  }

  static signFormatter(cell, row, index, extra) {
    let color = "green";
    let size = "8";

    if (!cell) {
      color = "red";
    } else if (cell < 90) {
      color = "red";
    } else if (cell < 99) {
      color = "orange";
    }

    let precision = 3;
    let value = cell;
    if (RespUtils.isNotTabletView()) {
      size = 16;
    }


    let imgSrc = "/images/" + color + "-" + size + ".png"
    return (<span><img src={imgSrc} /> {value}</span>)
  }

  static entityLink(cell, row) {
    // console.log(cell);
    if (!cell) {
      return cell;
    }

    return (<a className="black-a" href={"/pool/" + row.poolId}
      >{cell}</a>);
  }

  static renderEventTypes(thisObj) {
    if (window.innerWidth < 600) {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId}>All</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Add_Escrow"}>Del</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Auto_Escrow"}>Self Del</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Reclaim_Escrow"}>Reclaim-</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Transfer"}>Transfer</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Received"}>Received</a></td>
        </tr></tbody></table></div>);
    } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId}>All</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Add_Escrow"}>Add Escrow</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Auto_Escrow"}>Auto Escrow</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Reclaim_Escrow"}>Reclaim Escrow</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Transfer"}>Transfer</a></td>
          <td className="view-tag"><a className="black-a" href={"/events/" + thisObj.state.pool.poolId + "/Received"}>Received</a></td>
        </tr></tbody></table></div>);
    }
  }

  static renderNetworkEventTypes() {
    if (window.innerWidth < 600) {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a href={"/networkEvents"}>All</a> </td>
          <td className="view-tag"><a href={"/networkEvents/Add_Escrow"}>Del</a></td>
          <td className="view-tag"><a href={"/networkEvents/Auto_Escrow"}>Self Del</a></td>
          <td className="view-tag"><a href={"/networkEvents/Reclaim_Escrow"}>Reclaim Escrow</a></td>
          <td className="view-tag"><a href={"/networkEvents/Transfer"}>Transfer</a></td>
          <td className="view-tag"><a href={"/networkEvents/Received"}>Received</a></td>
        </tr></tbody></table></div>);
    } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a href={"/networkEvents"}>All</a></td>
          <td className="view-tag"><a href={"/networkEvents/Add_Escrow"}>Add Escrow</a></td>
          <td className="view-tag"><a href={"/networkEvents/Auto_Escrow"}>Auto Escrow</a></td>
          <td className="view-tag"><a href={"/networkEvents/Reclaim_Escrow"}>Reclaim Escrow</a></td>
          <td className="view-tag"><a href={"/networkEvents/Transfer"}>Transfer</a></td>
          <td className="view-tag"><a href={"/networkEvents/Received"}>Received</a></td>
        </tr></tbody></table></div>);
    }
  }

}

export default OasisUtils;



// WEBPACK FOOTER //
// ./src/oasis/OasisUtils.js